import React from 'react';
import {Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import styles from 'styles/informacionDelCard';
import { AssignmentOutlined } from '@mui/icons-material';

const ElementoDelCard = ({title, label, Icon}) => {
  const classes = styles();
  return (
    <Grid container className={classes.informationContainer}>
        <Grid item xs={4}>
            <Grid container >
                <Grid item xs={11}>
                    <Typography className={classes.title} >{title}</Typography>
                </Grid>
                <Grid item xs={1}>
                    <Icon className={classes.icon} />
                </Grid>
            </Grid>
        </Grid>
        <Grid item xs={8}>
            <Typography className={classes.description} >{label ? label : ""}</Typography>
        </Grid>
    </Grid>
  );
}
ElementoDelCard.defaultProps = {
    Icon : AssignmentOutlined
}

ElementoDelCard.propTypes = {
    title: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
};

export default ElementoDelCard;